import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e2b36c2e&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=e2b36c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b36c2e",
  null
  
)

export default component.exports